import { Switch, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { useDispatch } from 'react-redux';
import { setEventRegistration } from '../../../../../reduxToolkit/slices/commonSlice';
import { useSelector } from '../../../../../reduxToolkit/typedRedux';
import { updateMessagingSettings } from '../../../../../services/services';

const MessagingConfig = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const event = useSelector(({ common }) => common.event);
  const user = useSelector(({ common }) => common.user);
  const registration = useSelector(({ common }) => common.eventRegistration);

  const handleSettingsChange = async (updateObj: { messagingGhostMode?: boolean; messagingAllowNotifications?: boolean }) => {
    if (!event) return;
    try {
      await updateMessagingSettings(event._id, updateObj);
      dispatch(setEventRegistration({ ...registration, ...updateObj }));
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Table>
      <TableHead className="bg-slate-300">
        <TableRow>
          <TableCell>
            <p>{t('common:settings')}</p>
          </TableCell>
          <TableCell align="right" className="font-bold" />
        </TableRow>
      </TableHead>
      <TableBody key="ghostmode">
        {user?.role === 'PARTICIPANT_ANONYM' && (
          <>
            <TableRow key="row">
              <TableCell component="th" scope="row" style={{ width: '100%' }}>
                <p className="font-medium">{t('event:messaging.ghost-mode')}</p>
                <p className="font-small text-slate-500">{t('event:messaging.ghost-mode-description')}</p>
              </TableCell>
              <TableCell>
                <Switch checked={registration?.messagingGhostMode} onChange={(e) => handleSettingsChange({ messagingGhostMode: e.target.checked })} />
              </TableCell>
            </TableRow>
            <TableRow key="row">
              <TableCell component="th" scope="row" style={{ width: '100%' }}>
                <p className="font-medium">{t('event:messaging.allow-notifications')}</p>
                <p className="font-small text-slate-500">{t('event:messaging.allow-notifications-description')}</p>
              </TableCell>

              <TableCell>
                <Switch
                  checked={registration?.messagingAllowNotifications}
                  onChange={(e) => handleSettingsChange({ messagingAllowNotifications: e.target.checked })}
                />
              </TableCell>
            </TableRow>
          </>
        )}
      </TableBody>
    </Table>
  );
};
export default MessagingConfig;
